/* OPARINA mega menu: in the Accesorios tree the hovered or focused category shows its panel; on devices with a mouse
   the menus also open on hover (Sense keeps click and keyboard). A click right after a hover-open keeps the panel open
   instead of closing it. Sense's header-menu/details logic is untouched. */
(() => {
  if (window.ocMegaInit) return;
  window.ocMegaInit = true;
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const bind = (root) => {
    root.querySelectorAll('[data-oc-mtree]:not([data-bound])').forEach((tree) => {
      tree.dataset.bound = '1';
      const items = [...tree.querySelectorAll(':scope > .oc-mtree__i')];
      const show = (it) => items.forEach((x) => x.classList.toggle('is-on', x === it));
      items.forEach((it) => {
        const c = it.querySelector('.oc-mtree__c');
        c.addEventListener('pointerenter', () => show(it));
        c.addEventListener('focus', () => show(it));
      });
    });
    root.querySelectorAll('.header__inline-menu details.mega-menu:not([data-hover])').forEach((d) => {
      d.dataset.hover = '1';
      const li = d.closest('li');
      const summary = d.querySelector('summary');
      let leaveTimer;
      let hoverOpenedAt = 0;
      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !fine.matches) return;
        clearTimeout(leaveTimer);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((o) => {
          if (o !== d) o.open = false;
        });
        if (!d.open) {
          d.open = true;
          hoverOpenedAt = Date.now();
        }
      });
      li.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse' || !fine.matches) return;
        leaveTimer = setTimeout(() => { d.open = false; }, 180);
      });
      // a click that lands while the hover-open is fresh would toggle the panel shut: keep it open instead
      summary.addEventListener('click', (e) => {
        if (d.open && Date.now() - hoverOpenedAt < 1500) {
          e.preventDefault();
          hoverOpenedAt = 0;
        }
      }, true);
    });
  };
  const run = () => bind(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
})();
